import Axios from "axios";
import { SET_INV_RETURN_REPORT, UNSET_INV_RETURN_REPORT } from "@/store/mutation-types";
import { getInvReturnReport } from "@/store/api";

const state = { getInvReturnReport: {} };

const getters = {
  getInvReturnReport(state) {
    return state.getInvReturnReport;
  },
};

const mutations = {
  [SET_INV_RETURN_REPORT](state, data) {
    state.getInvReturnReport = data;
  },
  [UNSET_INV_RETURN_REPORT](state) {
    state.getInvReturnReport = {};
  },
};

const actions = {
  getInvReturnReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvReturnReport, { params: data })
        .then(function (response) {
          commit("SET_INV_RETURN_REPORT", response.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_INV_RETURN_REPORT");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default { state, getters, actions, mutations };
